module.exports = __webpack_public_path__ + "img/ET.401ff941.png";